import { createRouter, createWebHistory } from 'vue-router'
import { fetchCurrentH5User } from '../api/auth'
import { clearH5Session, getH5Token, saveH5User } from '../utils/auth'
import LoginView from '../views/LoginView.vue'
import ProfileView from '../views/ProfileView.vue'
import YouTubeDetailView from '../views/YouTubeDetailView.vue'
import YouTubeListView from '../views/YouTubeListView.vue'

const routes = [
  {
    path: '/',
    redirect: '/youtube'
  },
  {
    path: '/home',
    redirect: '/youtube'
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      public: true,
      showTabbar: false
    }
  },
  {
    path: '/youtube',
    name: 'youtube-list',
    component: YouTubeListView,
    meta: {
      showTabbar: true
    }
  },
  {
    path: '/youtube/detail',
    name: 'youtube-detail',
    component: YouTubeDetailView,
    meta: {
      showTabbar: false
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: ProfileView,
    meta: {
      showTabbar: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to) => {
  if (to.meta?.public === true) {
    return true
  }

  const token = getH5Token()
  if (!token) {
    return {
      path: '/login',
      query: {
        redirect: to.fullPath
      }
    }
  }

  try {
    const data = await fetchCurrentH5User({
      skipAuthRedirect: true
    })
    saveH5User(data?.user || null)
    return true
  } catch (_) {
    clearH5Session()
    return {
      path: '/login',
      query: {
        redirect: to.fullPath
      }
    }
  }
})

export default router
